import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  skeletonContainer: {
    width: '100%',

    [theme.breakpoints.up('large')]: {
      width: 'fit-content',
      margin: '0 auto',
    },
  },

  MapHeader: {
    height: '24px',
    width: '100%',
    display: 'flex',
    borderRadius: '8px',
    marginBottom: '14px',

    [theme.breakpoints.up('large')]: {
      width: '293px',
      height: '50px',
      borderRadius: '10px',
    },
  },

  mapInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    paddingBottom: '20px',

    [theme.breakpoints.up('large')]: {
      flexDirection: 'row',
      paddingBottom: '38px',
      gap: '16px',
    },
  },

  mapInfoDiv: {
    display: 'flex',
    width: '100%',
    height: '52px',
    borderRadius: '10px',

    [theme.breakpoints.up('large')]: {
      width: '216px',
      height: '68px',
    },
  },

  MapHeaderButton: {
    display: 'flex',
    width: '100%',
    height: '88px',
    borderRadius: '10px',

    [theme.breakpoints.up('large')]: {
      width: '447px',
      height: '68px',
    },
  },

  mapContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '15px',

    [theme.breakpoints.up('large')]: {
      flexDirection: 'row',
      alignItems: 'flex-start',
    },
  },

  mapDiv: {
    height: '360px',
    width: '100%',
    maxWidth: '631px',
    borderRadius: '10px',
    overflow: 'hidden',

    [theme.breakpoints.up('large')]: {
      width: '863px',
      maxWidth: 'none',
      height: '436px',
    },
  },

  stationInfoDiv: {
    width: '100%',
    height: '96px',
    borderRadius: '10px',

    [theme.breakpoints.up('large')]: {
      width: '237px',
      height: '150px',
    },
  },
}));
